import React, { Component, createRef } from "react";
import { Form, Input, Select, Checkbox, Upload, InputNumber, Radio } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { isFun } from "@utils/tool";
import bus from "@utils/bus";

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
let imgUrlKeys = [];

class FormSummary extends Component {
    constructor(props) {
        super(props);
        this.formRef = createRef();
        this.state = {
            operateType: "",
            editDefaultValue: {},
            loading: false
        };
    }

    // 代理 Form 方法给外部调用
    validateFields = () => {
        return this.formRef.current.validateFields();
    };

    setFieldsValue = (values) => {
        return this.formRef.current.setFieldsValue(values);
    };

    getFieldsValue = () => {
        return this.formRef.current.getFieldsValue();
    };

    resetFields = () => {
        return this.formRef.current.resetFields();
    };

    span(item) {
        return <span>{item.content}</span>;
    }

    input(item) {
        return (
            <Input
                placeholder={item.placeholder || `请填写${item.label}`}
                disabled={item.disabled || false}
            />
        );
    }

    inputNumber(item) {
        return (
            <InputNumber
                min={item.min}
                max={item.max}
                disabled={item.disabled || false}
            />
        );
    }

    textarea(item) {
        return (
            <TextArea
                placeholder={item.placeholder || `请填写${item.label}`}
                rows={item.rows || 2}
            />
        );
    }

    checkbox(item) {
        return <Checkbox>{item.placeholder || item.label}</Checkbox>;
    }

    radio(item) {
        return (
            <Radio.Group >
                {item.options.map((ele, index) => {
                    return (
                        <Radio key={index} value={ele.value}>{ele.label}</Radio>
                    );
                })}
            </Radio.Group>
        )
    }

    select(item) {
        return (
            <Select
                showSearch
                mode={item.mode || ""}
                allowClear={item.allowClear || false}
                placeholder={item.placeholder || `请选择${item.label}`}
                onChange={value => {
                    this.selectChange(value, item);
                }}
                optionFilterProp={item.filterKey || "children"}
                disabled={item.disabled || false}
            >
                {item.options.map((ele, index) => {
                    return (
                        <Option key={ele.value + index} value={ele.value}>
                            {ele.label}
                        </Option>
                    );
                })}
            </Select>
        );
    }

    upload(item) {
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        imgUrlKeys = [...imgUrlKeys, item.key];

        return (
            <Upload
                name="filecontent"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={item.uploadUrl}
                onChange={info => {
                    this.handleChange(info, item);
                }}
                disabled={item.disabled || false}
            >
                {this.state[item.key] ? (
                    <img
                        src={this.state[item.key]}
                        alt="avatar"
                        style={{ width: 126, height: 126 }}
                    />
                ) : (
                    uploadButton
                )}
            </Upload>
        );
    }

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    handleChange = (info, item) => {
        if (info.file.status === "uploading") {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === "done") {
            this.getBase64(info.file.originFileObj, imageUrl => {
                let obj = { loading: false };

                obj[item.key] = imageUrl;

                this.setState(obj);
            });
        }
    };

    selectChange = (value, item) => {
        if (isFun(item.onChange)) {
            item.onChange(value, item);
        }
    };

    beforeEdit = () => {
        let tempVal = this.props.formDefaultValue;

        if (imgUrlKeys.length > 0) {
            let obj = {};

            imgUrlKeys.forEach(item => {
                obj[item] = tempVal[item];
            });

            this.setState(obj);
        }

        this.formRef.current && this.formRef.current.setFieldsValue(tempVal);
    };

    handleBusFormSummary = data => {
        console.log("bus ...");
        this.formRef.current && this.formRef.current.setFieldsValue(data);
    };

    // 暴露表单方法给父组件
    getForm = () => {
        return this.formRef.current;
    };

    componentDidMount() {
        setTimeout(() => {
            this.beforeEdit();
        }, 0);

        bus.subscribe("form_summary", this.handleBusFormSummary);

        // 如果父组件传入了 onFormReady 回调，则调用它
        if (this.props.onFormReady) {
            this.props.onFormReady(this.formRef.current);
        }
    }

    render() {
        const returnFormItemLayout = hasLabel => {
            if (hasLabel) {
                return { ...formItemLayout };
            } else {
                return { ...tailFormItemLayout };
            }
        };
        const col = this.props.labelCols || 5;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: col }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 23 - col }
            }
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0
                },
                sm: {
                    span: 24 - col,
                    offset: col
                }
            }
        };
        const formItems = this.props.formItems || [];

        return (
            <Form ref={this.formRef}>
                {formItems.map((item, index) => {
                    return (
                        <FormItem
                            {...returnFormItemLayout(item.label || false)}
                            label={item.label}
                            key={item.key + index}
                            name={item.key}
                            rules={item.rules || [
                                {
                                    required: item.require,
                                    message: item.message
                                }
                            ]}
                            valuePropName={item.componentName === 'checkbox' ? 'checked' : 'value'}
                        >
                            {this[item.componentName](item)}
                        </FormItem>
                    );
                })}
            </Form>
        );
    }
}

export default FormSummary;
